import * as React from 'react'
import { tryCatch } from '../../utils/tryCatch'
import { Schedule } from '../schedule/schedule'
import { EpisodeList } from '../episodeList/episodeList'
import { withFatalCheck } from '../error/withFatalCheck'
import { ICollection } from '../../selectors/collections'
import { CarouselCollection } from '../carousel/carouselCollection'
import * as stUtility from '../utilityClasses.module.scss'
import { Container } from 'DVWebNodeUI'

const CollectionValid = tryCatch((props: ICollection) => {
  const { collectionType } = props
  if (collectionType === 'schedule') {
    return <Schedule {...props} />
  } else if (collectionType === 'carousel') {
    return <Container className={stUtility.pageSection}>
      <CarouselCollection  {...props}/>
    </Container>
  }
  return <EpisodeList {...props} />
})

export const Collection = withFatalCheck(CollectionValid)
